export enum RECALLS_DASHBOARD_KEYS {
  PageSizePreference = "recalls-dashboard-page-size-preference"
}
